/**
 * The error every household request rejects with.
 *
 * **Its own module, deliberately.** It lived in `useHousehold.ts`, which
 * imports `api/client` — a module that THROWS at import time without
 * `VITE_API_BASE`. So anything reaching for this class inherited a hard
 * dependency on the transport being configured, and `rowFailure.ts` (issue
 * 359) is imported by two presentational row components that had no business
 * pulling the API client in at all. Four test files went red at IMPORT the
 * moment it did.
 *
 * A plain error class depending on the transport it describes was the wrong
 * shape regardless; the test failure only made it visible. `useHousehold.ts`
 * re-exports it, so every existing import path still works.
 *
 * `body` is FastAPI's bare `{"detail": "..."}` with no status in it, and the
 * status lives on the sibling `response` — which is why both are carried
 * here rather than one object. Tasks 5, 6 and 8 all need to tell a 400 from a
 * 403; `rowFailure.ts` needs both at once.
 */
export class HouseholdError extends Error {
  readonly body: unknown
  readonly status: number

  constructor(body: unknown, status: number) {
    super(`Household request failed with ${status}`)
    this.name = 'HouseholdError'
    this.body = body
    this.status = status
  }
}
